import { ObjectStatuses, EntityActions } from '../global-entities/global-enums';

export class UserGroup {
  public UserGroupId?: number;
  public Name: string;
  public PropertyId: number;
  public Status: ObjectStatuses;
  public Staff: Array<number>;
}

export class UserGroupUpdate {
  public UserGroupId?: number;
  public Name: string;
  public PropertyId: number;
  public Action: EntityActions;
  public Staff: Array<number>;
  public locales?: any;
  public isApprovalGroup: boolean;
}

export class UserGroupSearch {
  public UserGroupId?: number;
  public Properties: Array<number>;
  public Name: string;
  public StaffId?: number;
  public SendStaff: boolean;
}
export class UserGroupModel extends UserGroupUpdate {
  public selectedStaffList: Array<any>;
  public selectedStaffIds: Array<number>;
}

export class UserGroupList {
  createdAt: string;
  locale: any;
  propertyId: number;
  updatedAt: string;
  userGroupId: number;
  userGroupUsers: any[];
}

export class UserGroupConsoleReq {
  public offset: number;
  public limit: number;
  public propertyId: any;
  public isApprovalGroup?: ApprovalGroupEnum;
  public where: string;
}
export enum ApprovalGroupEnum {
  false = 0,
  true = 1,
}

export class UserGroupListVM extends UserGroupList {
  userGroupName?: string;
  staffCount?: number;
  propertyCode?: string;
  isApprovalGroup?: boolean;
}

export class StaffSearch {
  public StaffId: number;
  public DeptId: number;
  public DesgId: number;
  public OpenCalls: number;
  public IsLoggedIn: Boolean;
  public Sections: Array<number> = [];
  public Description: string;
  public Skills: Array<number> = [];
  public Designation: string;
  public Department: string;
  public AllOpenCalls: number;
}
